/**
 * Shared state for the main left nav collapse/expand.
 * Lets the top-bar hamburger expand the nav even when it's collapsed.
 */
import React, { useState, useEffect, useCallback, createContext, useContext } from 'react';

const STORAGE_KEY = 'sideNavCollapsed';

const SideNavContext = createContext({
  collapsed: false,
  setCollapsed: () => {},
  expandNav: () => {},
  toggleNav: () => {},
});

export function useSideNav() {
  const ctx = useContext(SideNavContext);
  return ctx;
}

export function SideNavProvider({ children }) {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      if (collapsed) localStorage.setItem(STORAGE_KEY, 'true');
      else localStorage.removeItem(STORAGE_KEY);
    } catch (_) {}
  }, [collapsed]);

  const expandNav = useCallback(() => setCollapsed(false), []);
  const toggleNav = useCallback(() => setCollapsed((c) => !c), []);

  const value = {
    collapsed,
    setCollapsed,
    expandNav,
    toggleNav,
  };

  return (
    <SideNavContext.Provider value={value}>
      {children}
    </SideNavContext.Provider>
  );
}
